import React from 'react';
import fr from 'facet-rest';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import Container from './Container';

const OutcomeInsights = ({ resource }) => {
  return (
    <IncludedRelationshipProvider
      relationship={resource.relationship(fr.relationships.insights.name)}
    >
      <Container />
    </IncludedRelationshipProvider>
  );
};

OutcomeInsights.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default OutcomeInsights;
